import { S } from "./empty-state.styles";

type Props = {
    title: string;
};

export const EmptyState = (props: Props) => {
    const { title = "" } = props;

    return (
        <S.EmptyState>
            <S.Hero>
                <S.SearchIcon />
            </S.Hero>

            <S.Title variant="body1">{title}</S.Title>
        </S.EmptyState>
    );
};
